import React from 'react'
import WhatsappTemplatePreview from './WhatsappTemplatePreview'

export default function WhatsappTemplatePreviewAdapter({ formData, context }) {
  const fromForm = formData && formData.previewComponents
  const fromDef = context && context.formDefinition && context.formDefinition.previewComponents
  const components = Array.isArray(fromForm) ? fromForm : (Array.isArray(fromDef) ? fromDef : [])
  return <WhatsappTemplatePreview components={components} />
}
